import React from 'react'
import { BTitle, BText } from '@prague-digi/ui-components'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import { ApiErrorInfo, Response } from '../../api/api'
import { appSelectors, modalDialogActions } from '../../redux'
import { PageControlButtons } from '../../components'
import { intl, IntlInterface } from '../../hoc'
import { ReduxState } from '../../types'
import { reloadPage } from '../../utils/url'
import { SUPPORT_PHONE } from '../../constants/commonConstants'
import koSmileImg from '../../assets/noSmile.svg'
import messages from '../../i18n'
import phoneIcon from '../../assets/phoneRinging.svg'
import Routes from '../../constants/routes'
import storage from '../../utils/localStorage'
import styles from './styles.scss'

interface Props extends IntlInterface {
  errorInfo: ApiErrorInfo
  hideAllModalDialogs: Function
  hideModalDialog: Function
  isOnlinePilot: boolean
  modalId: string
  onRetry: any
  push: any
}

export const ApiError: React.FC<Props> = ({
  errorInfo,
  hideAllModalDialogs,
  hideModalDialog,
  isOnline,
  modalId,
  onRetry,
  push,
  translate,
}: Props) => {
  const isNetErr = errorInfo.type === Response.networkError
  const canRetry = (errorInfo.type === Response.serverErrorRetry || isNetErr) && onRetry

  const saveButtonMessage =
    errorInfo.type === Response.serverErrorStop
      ? messages.errors.retryModalDialog.saveBtnStop
      : messages.errors.retryModalDialog.saveBtn

  const titleKO =
    errorInfo.type === Response.serverErrorStop
      ? messages.errors.retryModalDialog.titleKoStop
      : messages.errors.retryModalDialog.titleKO

  const descriptionKO =
    errorInfo.type === Response.serverErrorStop
      ? messages.errors.retryModalDialog.descriptionKoStop
      : messages.errors.retryModalDialog.descriptionKO

  const onSecondary = () => {
    hideAllModalDialogs()
    if (errorInfo.type === Response.serverErrorStop) {
      storage.clear()
      reloadPage()
    } else {
      push(Routes.EXIT)
    }
  }

  const onPrimary = () => {
    hideModalDialog(modalId)
    onRetry()
  }

  return (
    <div>
      <div className={styles.errorImageContainer}>
        <img alt="" src={koSmileImg} />
      </div>
      {canRetry ? (
        <>
          <BTitle type="h3" center>
            {translate(
              isNetErr
                ? messages.errors.retryModalDialog.titleNet
                : messages.errors.retryModalDialog.title
            )}
          </BTitle>

          <BText center type="primary">
            {translate(
              isNetErr
                ? messages.errors.retryModalDialog.description1Net
                : messages.errors.retryModalDialog.description1
            )}
          </BText>
        </>
      ) : (
        <>
          <BTitle type="h3" center>
            {translate(titleKO)}
          </BTitle>

          <BText center type="primary">
            {translate(descriptionKO)}
          </BText>
        </>
      )}
      {(canRetry || isOnline) && (
        <PageControlButtons
          onSubmit={canRetry ? onPrimary : onSecondary}
          secondaryAction={canRetry && isOnline && !isNetErr ? onSecondary : undefined}
          secondaryMessage={canRetry && isOnline && !isNetErr ? saveButtonMessage : undefined}
          submitMessage={canRetry ? messages.errors.retryModalDialog.retryBtn : saveButtonMessage}
          testId="retry"
        />
      )}
      <div className={styles.delimiter} />
      <BText center type="notice">
        {translate(messages.errors.retryModalDialog.description3)}
      </BText>
      <div className={styles.phoneImageContainer}>
        <img alt="" src={phoneIcon} />
      </div>
      <BText center type="primary" theme={styles.callUs}>
        {translate(messages.errors.retryModalDialog.callUs)}
      </BText>
      <BText center type="primary" theme={styles.supportPhone}>
        {SUPPORT_PHONE}
      </BText>
    </div>
  )
}

export default compose(
  connect(
    (state: ReduxState) => ({
      isOnline: appSelectors.selectFFlagOnline(state),
    }),
    {
      hideModalDialog: modalDialogActions.hideModalDialog,
      hideAllModalDialogs: modalDialogActions.hideAllModalDialogs,
      push,
    }
  ),
  intl
)(ApiError)
